<template>
  <IconWrapper name="change" :color="color" fillMode="stroke">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.1205 3.67188L9.10547 6.68642L12.1205 9.7015"
        stroke="#1B1B1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.0176 14.2988L15.0327 17.3133L12.0176 20.3284"
        stroke="#1B1B1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.12402 6.68555H15.6887C18.6217 6.68555 20.9994 9.06325 20.9994 11.9963C20.9994 13.9676 19.9253 15.6881 18.3304 16.6044"
        stroke="#1B1B1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.9448 17.3073H8.30976C5.37673 17.3073 2.99902 14.9297 2.99902 11.9966C2.99902 10.0814 4.01283 8.403 5.53308 7.46875"
        stroke="#1B1B1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </IconWrapper>
</template>

<script setup lang="ts">
import IconWrapper from './wrapper/wrapper.vue'

import type { ColorsType } from '@/types'

defineProps<{
  color: ColorsType
}>()
</script>
